var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tbody', [!_vm.rows.records || _vm.rows.records.length < 1 ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colSpan,
      "align": "center"
    }
  }, [_vm._v("No data found.")])]) : _vm._e(), _vm._l(_vm.rows.records, function (row) {
    return _c('tr', {
      key: row.member_id
    }, [_c('td', [_vm._v(_vm._s(row.gid))]), _c('td', {
      staticStyle: {
        "width": "260px",
        "max-width": "260px",
        "white-space": "normal"
      }
    }, [_c('div', {
      staticClass: "yellow-section"
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Group Code: ")]), _c('span', {
      staticClass: "info-row"
    }, [_vm._v(_vm._s(row.gcode))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Name: ")]), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(row.gname))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Status: ")]), _c('span', {
      class: row.status + '-status'
    }, [_vm._v(" " + _vm._s(row.status) + " ")])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Email: ")]), _c('span', {
      staticStyle: {
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(row.gemail || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Phone: ")]), _c('span', [_vm._v(_vm._s(row.gphone || "-"))])])])]), _c('td', [_c('div', {
      staticClass: "member-section"
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Total: ")]), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(row.total_members))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Pending: ")]), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(row.total_pending_members || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Active : ")]), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(row.activeCount || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Termed : ")]), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(row.termCount || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Withdrawn: ")]), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(row.withDrawnCount || "-"))])])])]), _c('td', {
      staticStyle: {
        "white-space": "pre-line",
        "word-break": "break-word"
      }
    }, [_vm._v(" " + _vm._s((row.plan_name_systems || "-").replace(/, /g, "\n")) + " ")]), _c('td', {
      staticStyle: {
        "width": "200px",
        "max-width": "260px",
        "white-space": "normal"
      }
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Renewal Date: ")]), _c('span', [_vm._v(_vm._s(row.renewal_date))])]), _c('br'), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Effective Date: ")]), _c('span', [_vm._v(_vm._s(row.group_effective_date || "-"))])])]), _c('td', {
      staticStyle: {
        "width": "50px",
        "max-width": "100px",
        "word-break": "break-word"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(row.remaining_days) + " ")])]), _c('td', {
      staticStyle: {
        "width": "260px",
        "max-width": "260px",
        "white-space": "normal"
      }
    }, [_c('div', {
      staticClass: "yellow-section"
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Rep Code: ")]), _c('span', [_vm._v(_vm._s(row.agent_code || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Name: ")]), _c('span', {
      staticClass: "rep-name"
    }, [_vm._v(_vm._s(row.agent_name))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Email: ")]), _c('span', {
      staticStyle: {
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(row.agent_email || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Phone: ")]), _c('span', [_vm._v(_vm._s(row.agent_phone1 || "-"))])])])])]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }